<template>
  <div :class="['message', `message-${value.role}`]">
    <div>
      <el-avatar>
        <img v-if="value.avatarImg" :src="value.avatarImg" />
        <span v-else> {{ value.avatarText }}</span>
      </el-avatar>
    </div>
    <div class="bubble">
      {{ value.needTyping ? typingDisplay : value.text + (value.isThinking ? loadingDsiplay : '') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadingDsiplay: '',
      loadingCount: 0,
      loadingRetard: 0,
      typingDisplay: '',
      typingCount: 0
    }
  },
  methods: {
    onUpdate() {
      if (this.value.isThinking) {
        if (this.loadingRetard == 0) {
          let index = 3 - this.loadingCount
          this.loadingDsiplay = '...'.slice(index)
          this.loadingCount++
          this.loadingCount %= 4
        }
        this.loadingRetard++
        this.loadingRetard %= 3
      } else if (this.value.needTyping) {
        this.typingCount += 2
        this.typingDisplay = this.value.text.substring(0, this.typingCount)

        if (this.typingCount > this.value.text.length) {
          this.$emit('typingFinish')
        }
      }
    },
    needUpdate() {
      return this.value.isThinking || this.value.needTyping
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'message',
  (
    --start-color: #4bc3ff,
    --end-color: #9769ff
  ),
  (
    --start-color: #4bc3ff,
    --end-color: #9769ff
  )
);

.message {
  @include adaptation(
    (
      --bubble-border-image-width: 26px
    )
  );

  display: flex;
  margin: var(--base-size-12) 0;

  &.message-user {
    flex-direction: row-reverse;

    .bubble {
      margin-right: var(--base-size-16);
      color: var(--base-color-white);
      border-radius: var(--base-size-8);
      border-image: url('~@/assets/images/chatrobot/pop-blue.png') 102 round;
      border-image-width: var(--bubble-border-image-width);
      background: linear-gradient(95deg, var(--start-color) 2.68%, var(--end-color) 97.08%);
      background-origin: border-box;
    }
  }

  &.message-assistant {
    flex-direction: row;

    .bubble {
      margin-left: var(--base-size-16);
      color: var(--base-color-white);
    }
  }

  .bubble {
    font-size: var(--base-font-size-medium);
    max-width: 80%;
    position: relative;
    white-space: pre-wrap;
    border-style: none;
    border: var(--base-size-16) solid transparent;
    border-image: url('~@/assets/images/chatrobot/pop-light.png') 102 round;
    border-image-width: var(--bubble-border-image-width);
  }
}
</style>
